/** Saudi / Qawaem product identity */
export const SAUDI_BRAND = {
  appName: 'قوائم',
  appSubtitle: 'نظام تخطيط موارد المؤسسات',
  browserTitle: 'قوائم — نظام ERP',
  defaultLocale: 'ar',
  direction: 'rtl',
  currency: 'SAR',
  vatRate: 15,
};

/** Build placeholder route for sections not yet wired */
export function saudiPendingHref(moduleId, sectionId) {
  return `/saudi/pending/${moduleId}/${sectionId}`;
}
